/* global safari */

'use strict';

import components from './components.js';
import pick from 'lodash/pick';
import $ from 'jquery';

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const validateEmail = email => {
  // eslint-disable-next-line no-useless-escape
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

/**1
 * Validate a phone number
 * @param {string} number phone number
 * @returns {boolean} true if considered to be valid phone number false otherwise
 */
const validatePhone = number => {
  // eslint-disable-next-line no-useless-escape
  return /^[\d\-\+\ ]+$/.test(number);
};

const getToken = cb => {
  let token;
  $.ajax({
    type: 'GET',
    dataType: 'json',
    async: true,
    url: '/stage-ajax/get-token/',
    success: data => {
      token = data.token;

      if (cb) cb(token);
    },
  });
};

const urlParams = (() => {
  if (/\?/gi.test(location.href)) {
    var params = location.href.split('?')[1];
    var obj = {};

    // eslint-disable-next-line no-useless-escape
    if (/\&/gi.test(params)) {
      params = params.split('&');

      params.forEach(param => {
        obj[param.split('=')[0]] = param.split('=')[1];
      });
    } else {
      obj[params.split('=')[0]] = params.split('=')[1];
    }

    return obj;
  } else {
    return false;
  }
})();

const isInt = value => {
  let x;
  if (isNaN(value)) {
    return false;
  }
  x = parseFloat(value);
  return (x | 0) === x;
};

const shuffle = a => {
  /**
   * Shuffles array in place.
   * @param {Array} a items The array containing the items.
   */
  let j, x, i;
  for (i = a.length; i; i--) {
    j = Math.floor(Math.random() * i);
    x = a[i - 1];
    a[i - 1] = a[j];
    a[j] = x;
  }
};

/**
 * If a given value is below then a string is returned with a leading zero. If a value
 * is bigger than then value it self is returned.
 * @param {number} value numberic value
 * @returns {string|number}
 *
 * @example
 * setDoubleDigits(2)//'02'
 * setDoubleDigits(-2)//'0-2' - this is not propably a proper use case
 * setDoubleDigits(0)//'00'
 * setDoubleDigits(100)//100 - value it self is returned
 */
const setDoubleDigits = value => {
  if (parseInt(value) < 10) return '0' + value;
  return value;
};

const formatNumber = function(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/**
 * Format money with a fixed two decimals.
 * @param {number} value value
 * @returns {string} formatted money string
 *
 * @example
 * formatMoney(20.333)//"20.33 €"
 * formatMoney(-20.333)//"-20.33 €"
 */
const formatMoney = function(value) {
  return formatNumber(value.toFixed(2).replace('.', ',')) + ' €';
};

const decryptMail = $element => {
  let mail = $element.attr('data-href');

  if (mail) {
    mail = mail
      .split('')
      .reverse()
      .join('')
      .replace(/\|/, '@');

    $element.attr('href', 'mailto:' + mail);
    $element.attr('data-href', 'mailto:' + mail);
    if ($element.text() === '') $element.text(mail);
  }
};

const articlePageHeights = () => {
  if ($('article').length > 0 && $('.bg-dark').length > 0) {
    $('article').css({
      'min-height': 0,
    });

    if ($('article').height() < $('.bg-dark').height()) $('article').css('min-height', $('.bg-dark').height());
    else $('article').css('height', 'auto');

    $('iframe').css({
      'max-width': '100%',
    });

    $('iframe[src*="youtube"]').height($('iframe[src*="youtube"]').width() / 1.77);
  }
};

const getParameterByName = name => {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const parseUrl = u => {
  let a = [];

  $.each(u.split('&'), (i, c) => {
    a.push({
      name: c.split('=')[0],
      value: c.split('=')[1],
    });
  });

  return a;
};

/**
 * Validate a Finnish license number by matching it with a regular expression.
 * @param {string} license license number
 * @returns {object|null} If value is a match object is returned otherwise null
 */
const validateLicense = license => {
  return license.match(/^[a-zA-ZåäöÅÄÖ]{2,3}-\d{1,3}$/);
};

const init = () => {
  $('.lift-card-holder a, .car-card-holder a').on('click', function(e) {
    var self = $(this);

    if (/youtube/gi.test(self.attr('href'))) {
      e.preventDefault();

      var iframeMarkUp =
        '<iframe frameborder="0" id="youtube-iframe" webkitallowfullscreen mozallowfullscreen allowfullscreen llowfullscreen="1" src="' +
        self.attr('href') +
        '"></iframe>';
      components.popup(iframeMarkUp, () => {});
    }
  });

  if ($('.caplan-link').length > 0) {
    $('.caplan-link')
      .find('a')
      .click(function(e) {
        const self = $(this);
        const license = self.prev('input');

        e.preventDefault();

        if (validateLicense(license.val())) {
          license.parent('div').removeClass('stage-error');
          location.href = self.attr('href') + license.val();
        } else license.parent('div').addClass('stage-error');
      });
  }

  if ($('.proautolasi-link').length > 0) {
    $('.proautolasi-link')
      .find('a')
      .click(function(e) {
        var self = $(this);
        var license = self.prev('input');

        e.preventDefault();

        if (validateLicense(license.val())) {
          license.parent('div').removeClass('stage-error');
          location.href = self.attr('href') + license.val() + '/proautolasipalvelu';
        } else license.parent('div').addClass('stage-error');
      });
  }
};

/**
 * Capitalize first letter of given string
 * @param {*} string text to be capitalized
 * @returns {*} return capitalized string if given value type is string otherwise given value is just returned back.
 */
function jsUcfirst(string) {
  if (typeof string !== 'string') return string; // Don't know what to do with this because it's not a string
  return string.charAt(0).toUpperCase() + string.slice(1);
}

let browser = '';
function BrowserDetection() {
  if (browser === '') {
    switch (true) {
    case !!document.documentMode:
      browser = 'MSIE';
      break;
    case !!window.StyleMedia:
      browser = 'EDGE';
      break;
    case !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime):
      browser = 'CHRM';
      break;
    case typeof InstallTrigger !== 'undefined':
      browser = 'FFOX';
      break;
    case /constructor/i.test(window.HTMLElement) ||
        (function(p) {
          return p.toString() === '[object SafariRemoteNotification]';
        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)):
      browser = 'SFRI';
      break;
    default:
      browser = 'UNKW';
      break;
    }
  }
  return browser;
}

/**
 * Return car search url address, function can be used in brand specific sites as laakkonen.fi "top" domain.
 * @param {string} url - url address
 * @return {string} cars search relative url address, something like /bmw/autohaku/
 *
 * @example
 * ```
 * getCarSearchURL('/'); --> '/autohaku/'
 * getCarSearchURL(''); --> /autohaku/'
 * getCarSearchURL('/skoda/autohaku'); --> /skoda/autohaku/'
 * getCarSearchURL('/bmw'); --> /bmw/autohaku/'
 * getCarSearchURL('/bmw/autot/parhaat/autot'); --> /bmw/autohaku/'
 * ```
 */
function getCarSearchURL(url) {
  const brands = ['bmw', 'skoda', 'skoda-uusi', 'mazda', 'opel', 'mini', '/bmw-uusi-2/', 'ford', 'nissan', 'subaru'];

  const carSearchSuffix = url.indexOf('autohaku') === -1 ? 'autohaku/' : '';

  const carSearchPaths = brands.map(brand => brand + carSearchSuffix);

  let carSearchURL = '';

  const paths = url.split('/').filter(Boolean);

  for (let i = 0; i < paths.length; i++) {
    if (carSearchPaths.includes(`${paths[i]}/${paths[i + 1]}`)) {
      carSearchURL += paths[i] + '/' + carSearchSuffix;
      break;
    }

    if (brands.includes(paths[i])) {
      carSearchURL += paths[i] + '/' + carSearchSuffix;
      break;
    }

    carSearchURL += paths[i] + '/';
  }

  if (paths.length <= 1) {
    carSearchURL += carSearchSuffix;
  }

  return `/${carSearchURL}`;
}

/**
 * A quick content hasher. Not md5, not secure, low tech low security. Generates a hash from an quickly.
 * @param {*} inputRaw The content, can be pretty much anything. Best effort will be given to transform it into a digit, regardless of what it actually is.
 * @return {int} digest integer from given input
 */
function hashCode(inputRaw) {
  const input = `${inputRaw}${typeof inputRaw}${Math.PI}`;

  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash = hash & hash; // Convert to 32bit integer
  }

  return parseInt(String(hash / Number.MAX_SAFE_INTEGER).substring(4, 14));
}

/**
 * A pseudo identifier that isn't based on a cookie, but creates a semi-unique "fingerprint" for the browser.
 * Very unreliable. May change at any time, can have duplicates. Only use for lowest priority stuff like statistical/analytics things.
 * @return {int} Pseudo ID.
 */
function noCookieId() {
  return hashCode(Object.values(pick(window.navigator, ['appName', 'appVersion', 'cookieEnabled', 'languages', 'platform', 'userAgent'])));
}

/**
 * Update object with a given path
 * @param {object} targetObject target object
 * @param {string} targetPath path to target attribute in the target object
 * @param {*} val value to replace item in the path
 * @param {*} forceUpdate force update whole target object
 * @returns {object} manipulated object
 *
 * @example
 * deepUpdate(olio2, 'name', 'Kukkeli' );// { name: 'Kukkeli', position: { x: 1, y: 2, z: 3 } }
 * deepUpdate(olio2, 'position.y', 30 );// { name: 'Ukkeli', position: { x: 1, y: 30, z: 3 } }
 * deepUpdate(olio2, 'position', { z: 20 }, true );// { name: 'Ukkeli', position: { z: 20 } }
 */
function deepUpdate(targetObject, targetPath, val, forceUpdate = false) {
  // Recursive function. Calls itself deeper and deeper until at the end of the path, then unravels back

  // Can't target non-string path
  if (typeof targetPath !== 'string' || typeof targePath === 'string' && targetPath.length === 0) {
    return targetObject;
  }

  // Can't modify non-object
  if (typeof targetObject !== 'object' || targetObject === null) {
    return targetObject;
  }

  const [parentPath, offspringPath] = targetPath.split(/\.(.*)/); // Split path to current location and remainder target address

  let patch = {};
  if (offspringPath && offspringPath.length && !targetObject[parentPath]) {
    // Need help creating offspring path that doesn't exist
    patch[parentPath] = {};
  } else {
    patch = { ...targetObject };
  }

  // Recursion: fork or stop
  if (offspringPath && offspringPath.length && ['object', 'undefined'].includes(typeof targetObject[parentPath])) {
    // Still some path ahead, fork a recursive call
    patch[parentPath] = deepUpdate(patch[parentPath], offspringPath, val);
  } else if (typeof targetObject[parentPath] !== 'object') {
    patch[parentPath] = val;
  } else if (typeof targetObject[parentPath] === 'object' && forceUpdate) {
    patch[parentPath] = val;
  }

  return {
    ...targetObject,
    ...patch,
  };
}

/**
 * Test is viewport smaller than tablet-portrait size 768px.
 *
 * @returns {boolean} true if it is false it not
 */
function isMobileViewSize() {
  return window.innerWidth <= 768;//Smaller than tablet-portrait
}

export default {
  getCarSearchURL,
  isNumber,
  validateEmail,
  validatePhone,
  getToken,
  urlParams,
  isInt,
  shuffle,
  setDoubleDigits,
  decryptMail,
  articlePageHeights,
  getParameterByName,
  parseUrl,
  validateLicense,
  formatNumber,
  formatMoney,
  init,
  jsUcfirst,
  BrowserDetection,
  hashCode,
  noCookieId,
  isMobileViewSize
};

export {
  getCarSearchURL,
  isNumber,
  validateEmail,
  validatePhone,
  getToken,
  urlParams,
  isInt,
  shuffle,
  setDoubleDigits,
  decryptMail,
  articlePageHeights,
  getParameterByName,
  parseUrl,
  validateLicense,
  formatNumber,
  formatMoney,
  init,
  jsUcfirst,
  BrowserDetection,
  hashCode,
  noCookieId,
  deepUpdate,
  isMobileViewSize
};
